import { useState } from "react";
import React, { useEffect } from "react";
import plusIcon from "../assets/plusIcon.png";
import trashIcon from "../assets/trashIcon.png";
import useProductStore from "../store/productStore";
import useOrderItemsStore from "../store/orderItemsStore";
import { FaMinusSquare } from "react-icons/fa";

const AddOrder = ({ items }) => {
  const [quantidade, setQuantidade] = useState("");
  const [valorAlvo, setValorAlvo] = useState("");
  const [valorUnitario, setValorUnitario] = useState("");
  const [total, setTotal] = useState("0.00");

  const { products } = useProductStore();
  const [selectedProduct, setSelectedProduct] = useState("");
  const { orderItems, addOrderItem, clearOrderItems, removeOrderItem } =
    useOrderItemsStore();

  const handleChange = (event) => {
    setSelectedProduct(event.target.value);
  };

  const onHandleAddOrderItems = () => {
    if (!products || products.length === 0) {
      console.error("Lista de produtos não carregada.");
      return alert("Erro ao carregar produtos. Tente novamente.");
    }

    const product = products.find((p) => String(p.id) === selectedProduct);

    if (!product) {
      console.error("Produto não encontrado ou não selecionado.");
      return alert("Selecione um produto válido.");
    }

    if (
      isNaN(parseInt(quantidade, 10)) ||
      isNaN(parseFloat(valorAlvo)) ||
      isNaN(parseFloat(valorUnitario))
    ) {
      console.error("Preencha todos os campos numéricos corretamente.");
      return alert("Por favor, preencha todos os campos corretamente.");
    }

    const newItem = {
      id: product.id,
      name: product.name,
      quantity: parseInt(quantidade, 10),
      target_value: parseFloat(valorAlvo).toFixed(2),
      unit_value: parseFloat(valorUnitario).toFixed(2),
      total_value: (quantidade * valorAlvo).toFixed(2),
    };

    addOrderItem(newItem);

    setSelectedProduct("");
    setQuantidade("");
    setValorAlvo("");
    setValorUnitario("");
    setTotal("0.00");
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 min-h-[330px] text-boldGray opacity-90">
      <div className="overflow-x-auto max-w-[1560px] custom-scrollbar">
        <table className="w-full table-auto border-collapse">
          <thead>
            <tr className="uppercase bold text-base md:text-xs xl:text-base">
              <th className="py-4 w-[20%] ">Item</th>
              <th className="py-4 w-[20%] ">Quantidade</th>
              <th className="py-4 w-[20%] ">Valor alvo</th>
              <th className="py-4 w-[20%]  ">Valor unitário</th>
              <th className="py-4 w-[20%] ">Total</th>
              <th className="py-4  "></th>
            </tr>
          </thead>
        </table>
        <div className="overflow-y-auto max-h-[130px] mt-2 custom-scrollbar">
          <table className="table-auto border-collapse w-full">
            <tbody className="space-y-4">
              {orderItems.map((order, index) => (
                <tr
                  key={index}
                  className="text-center bg-[#E7E7E7] w-full h-[64px] md:text-xs xl:text-base "
                >
                  <td className="py-4 w-[20%] ">
                    <div className="line-clamp-2">{order.name}</div>
                  </td>
                  <td className="py-4 w-[12%]">{order.quantity}</td>
                  <td className="py-4 w-[12%]">$ {order.target_value}</td>
                  <td className="py-4 w-[12%]">$ {order.unit_value}</td>
                  <td className="py-4 w-[12%]">$ {order.total_value}</td>
                  <td className="py-4 w-[4%]">
                    <button
                      className="text-red-500 w-8 "
                      onClick={() => removeOrderItem(index)}
                      type="button"
                    >
                      <FaMinusSquare />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="w-full">
        <div className="h-[20px]"></div>
        <div className="bg-white text-center h-[60px] rounded-md flex flex-wrap md:text-xs xl:text-base">
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <select
              id="productSelect"
              value={selectedProduct}
              onChange={handleChange}
            >
              <option value="">Selecione um produto</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Quantidade"
              type="number"
              className="text-center focus:outline-none w-full"
              value={quantidade}
              onChange={(e) => setQuantidade(e.target.value)}
            />
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Valor alvo"
              type="number"
              className="text-center focus:outline-none w-full"
              value={valorAlvo}
              onChange={(e) => setValorAlvo(e.target.value)}
            />
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Valor unitário"
              type="number"
              className="text-center focus:outline-none w-full"
              value={valorUnitario}
              onChange={(e) => setValorUnitario(e.target.value)}
            />
          </div>
          {/* <div className="flex-1 py-4 px-2 border-l border-lightGray h-[60px]">
            <input
              placeholder="Total"
              type="text"
              className="text-center focus:outline-none bg-white w-full"
              value={`R$ ${total}`}
              onChange={(e) => setTotal(e.target.value)}
              disabled
            />
          </div> */}
          <div className="flex justify-center items-center py-4 px-2">
            <button
              className="flex justify-center items-center"
              type="button"
              onClick={() => onHandleAddOrderItems()}
            >
              <img src={plusIcon} alt="Adicionar" />
            </button>
          </div>
          <div className="w-[20px]"></div>
        </div>
      </div>
    </div>
  );
};

export default AddOrder;
